import { createApiCall } from 'lib/base';

const FETCH_STOCK_EVENT_DETAIL_API_ID = 'DASHBOARD/FETCH_STOCK_EVENT_DETAIL_API';

const apiCall = createApiCall(FETCH_STOCK_EVENT_DETAIL_API_ID, ({ id }) => ({
  endpoint: `/api/admin/stock-events/${id}`,
  method: 'GET',
}));

export default apiCall;
